import {
  Swiper, Navigation, Pagination, Autoplay, Controller, Thumbs,
} from 'swiper';

// Configure Swiper modules
Swiper.use([Navigation, Pagination, Autoplay, Controller, Thumbs]);

document.addEventListener('DOMContentLoaded', () => {
  const helpsSection = document.querySelector('.helps');
  const helpsContainer = document.querySelector('.helps__slider');
  let helpsSlider;

  const sponsorsSection = document.querySelector('.sponsors');
  const sponsorsContainer = document.querySelector('.sponsors__slider');
  let sponsorsSlider;

  const reviewSection = document.querySelector('.review');
  const reviewContainer = document.querySelector('.review__grid');
  let reviewSlider;

  const selectionSlides = document.querySelector('.selection__slides');
  const selectionContainerMobile = document.querySelector('.js-selection-bread-crumbs');
  const selectionStepsContainer = document.querySelector('.selection__steps_mobile');
  let selectionSlider;
  let selectionStepsSlider;
  let selectionContainerBreadCrumbs;

  const initSliders = () => {
    if (window.isMobile() && (!helpsSlider || !sponsorsSlider || !reviewSlider)) {
      if (helpsContainer) {
        helpsSlider = new Swiper(helpsContainer, {
          speed: 400,
          loop: true,
          navigation: false,
          pagination: {
            el: '#helps-swiper-pagination',
            type: 'bullets',
          },
        });
      }

      if (sponsorsContainer) {
        sponsorsSlider = new Swiper(sponsorsContainer, {
          speed: 400,
          slidesPerView: 3,
          loop: true,
          navigation: false,
        });
      }

      if (reviewContainer) {
        reviewSlider = new Swiper(reviewContainer, {
          speed: 400,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            prevEl: '.review__arrow--prev',
            nextEl: '.review__arrow--next',
          },
        });
      }
    } else if (!window.isMobile() && (helpsSlider || sponsorsSlider)) {
      if (helpsSlider) {
        helpsSlider.destroy();
        helpsSlider = null;
      }

      if (sponsorsSlider) {
        sponsorsSlider.destroy();
        sponsorsSlider = null;
      }
    }

    if (!window.isMobile() && !reviewSlider && reviewContainer) {
      reviewSlider = new Swiper(reviewContainer, {
        speed: 400,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          prevEl: '.review__arrow--prev',
          nextEl: '.review__arrow--next',
        },
      });
    } else if (window.isMobile() && reviewSlider) {
      reviewSlider.destroy();
      reviewSlider = null;
    }
  };

  if (selectionSlides) {
    let autoplay = true;

    if (window.IntersectionObserver) {
      autoplay = false;

      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio === undefined) {
          return;
        }

        if (entries[0].intersectionRatio <= 0) {
          selectionSlider.autoplay.stop();
        } else {
          selectionSlider.autoplay.start();
        }
      });

      observer.observe(selectionSlides);
    }

    const liClassName = 'active';
    const liControllers = document.querySelector('.selection__steps')?.querySelectorAll('li') || [];

    const controlSlider = (index) => {
      liControllers.forEach((item) => item.classList.remove(liClassName));

      if (liControllers[index]) {
        liControllers[index].classList.add(liClassName);
      }
    };

    selectionSlider = new Swiper(selectionSlides, {
      speed: 400,
      autoplay,
      loop: false,
      runCallbacksOnInit: false,
      cssMode: true,
      on: {
        slideChangeTransitionEnd() {
          controlSlider(this.realIndex);

          if (selectionStepsSlider) {
            selectionStepsSlider.slideTo(this.activeIndex, 400, false);
          }
        },
      },
      navigation: {
        prevEl: '.selection__arrow--prev',
        nextEl: '.selection__arrow--next',
      },
      thumbs: {
        swiper: selectionContainerBreadCrumbs,
      },
    });

    if (selectionContainerMobile) {
      selectionContainerBreadCrumbs = new Swiper(selectionContainerMobile, {
        speed: 400,
        autoplay,
        loop: false,
        controller: {
          by: selectionSlider,
        },
      });

      selectionContainerBreadCrumbs.controller.control = selectionSlider;
      selectionSlider.controller.control = selectionContainerBreadCrumbs;
    }

    if (selectionStepsContainer) {
      selectionStepsSlider = new Swiper(selectionStepsContainer, {
        speed: 400,
        autoplay,
        loop: true,
        runCallbacksOnInit: false,
        on: {
          slideChangeTransitionEnd() {
            controlSlider(this.realIndex);
            selectionSlider.slideTo(this.activeIndex, 400, false);
          },
        },
      });
    }

    liControllers.forEach((item, index) => {
      item.addEventListener('click', () => {
        selectionSlider.slideTo(index, 400, false);
        controlSlider(index);
      });
    });
  }

  if (helpsSection || sponsorsSection || reviewSection) {
    initSliders();

    window.addEventListener('resize', () => {
      initSliders();
    });
  }
});
